import React, { Component, isValidElement } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import { Modal } from "../Modal";
const messages = defineMessages({
    ok: {
        id: "confirm.ok",
        defaultMessage: "Ok"
    },
    cancel: {
        id: "confirm.cancel",
        defaultMessage: "Cancel"
    }
});
function getLabel(value) {
    if (value != null && typeof value === "object" && !isValidElement(value)) {
        return (<FormattedMessage {...value} // tslint:disable-line:jsx-curly-spacing
        />);
    }
    return value;
}
let nextId = 0;
class Confirm extends Component {
    constructor() {
        super(...arguments);
        this._id = `confirm-modal-${nextId++}`;
    }
    render() {
        const { props } = this;
        return (<Modal id={this._id} isActiveModal={props.open} modalId={this._id} triggerId={props.triggerId || ""} closeModal={props.onCancel}>
				<div className="vr vr_x5">
					{props.children}
				</div>
				<div>
					<button type="button" className="btn btn-action" onClick={props.onOk}>
						{getLabel(props.okLabel || messages.ok)}
					</button>{" "}
					<button type="button" className="btn btn-action" onClick={props.onCancel}>
						{getLabel(props.cancelLabel || messages.cancel)}
					</button>
				</div>
			</Modal>);
    }
}
export default Confirm;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/Confirm/Confirm.tsx